// React imports
import React from 'react';

// Project imports
import OpportunityOneOffBaseScreen from './OpportunityOneOffBaseScreen';
import OpportunityOneOffEmailBuilder from './OpportunityOneOffEmailBuilder';
import OpportunityPreviewAndSendOneOffEmail from './OpportunityPreviewAndSendOneOffEmail';

function OpportunityOneOffEmailScreen(props) {
    return (
        <OpportunityOneOffBaseScreen
            type='one-off-email'
            Builder={OpportunityOneOffEmailBuilder}
            PreviewAndSend={OpportunityPreviewAndSendOneOffEmail}
            {...props}
        />
    );
}

export default OpportunityOneOffEmailScreen;
